import api from './api';

/**
 * Reviews Service
 * Produktbewertungen abrufen und einreichen
 */
const reviewsService = {
  getProductReviews: (productId) => api.get(`/reviews/${productId}`),
  submitReview: (productId, data) => api.post(`/reviews/${productId}`, data)
};

export default reviewsService;
